import React, { useEffect } from "react";
import Contactarea from "../Contactarea";
import { BASE_URL } from "../Config/Config";
import SubLoading from "../ALL CSS/Loading";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

function GetinTouch() {
  // ✅ Fetch banner using React Query
  const {
    data: bannerData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["contactBanner"],
    queryFn: async () => {
      const res = await fetch(`${BASE_URL}/banner/?page=contact`);
      const json = await res.json();
      return json.data?.[0];
    },
  });

  // Image/Mask/Color automation effect
  useEffect(() => {
    const setBackgrounds = () => {
      document.querySelectorAll("[data-bg-src]").forEach((el) => {
        const src = el.getAttribute("data-bg-src");
        if (src) {
          el.style.backgroundImage = `url(${src})`;
          el.classList.add("background-image");
          el.removeAttribute("data-bg-src");
        }
      });

      document.querySelectorAll("[data-bg-color]").forEach((el) => {
        const color = el.getAttribute("data-bg-color");
        if (color) {
          el.style.backgroundColor = color;
          el.removeAttribute("data-bg-color");
        }
      });

      document.querySelectorAll("[data-mask-src]").forEach((el) => {
        const mask = el.getAttribute("data-mask-src");
        if (mask) {
          el.style.maskImage = `url(${mask})`;
          el.style.WebkitMaskImage = `url(${mask})`;
          el.classList.add("bg-mask");
          el.removeAttribute("data-mask-src");
        }
      });
    };

    setBackgrounds();
  }, []);

  // Loading State
  if (isLoading) return <SubLoading />;

  // Error State
  if (isError || !bannerData?.image) return <div>Error loading banner</div>;

  return (
    <>
      {/* Banner Section */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: `url(${BASE_URL}${bannerData.image})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
        }}
        data-overlay="title"
        data-opacity={8}
      >
        <div
          className="breadcumb-shape"
          data-bg-src="/assets/img/bg/breadcumb_shape_1_1.png"
        ></div>

        <div
          className="shape-mockup breadcumb-shape2 jump d-lg-block d-none"
          data-right="30px"
          data-bottom="30px"
        >
          <img src="/assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
        </div>

        <div
          className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none"
          data-left="50px"
          data-bottom="80px"
        >
          <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
        </div>

        <div className="container">
          <div className="breadcumb-content text-center">
            <h1 className="breadcumb-title">Contact Us</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Contact Area */}
      <Contactarea />
    </>
  );
}

export default GetinTouch;
